import { render, staticRenderFns } from "./VTableHistory.vue?vue&type=template&id=edaf61c4&scoped=true"
import script from "./VTableHistory.vue?vue&type=script&lang=js"
export * from "./VTableHistory.vue?vue&type=script&lang=js"
import style0 from "./VTableHistory.vue?vue&type=style&index=0&id=edaf61c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edaf61c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
